define('shared/initializer/form/adapters/mixins/OfferValidatable',[
    'shared/page/wcmmode',
    'shared/lib/RSVP',
    'shared/util/state',
    'shared/remote/offer/validate',
    'shared/remote/offer/get',
    'shared/initializer/form/constants'
],
function(getWCMMode, RSVP, state, validateOffer, getOffer, constants){

    var DISABLED = 'disabled';

    function createError(type, message){
        var err = new Error(message);
        err.type = type;
        return err;
    }

    function validate(offerId, wcmmode) {
        var me = this;
        // check if offer id is valid for current user
        // we don't have to wait the task to be finished here
        // but we do need to wait before submit
        offerId = offerId >> 0;

        if ( offerId == 0 && wcmmode !== DISABLED ) {
            return RSVP.resolve();
        }

        me.dfdOfferValidatable.push(
            validateOffer({
                id: offerId
            })
            .then(null, function(){
                return state
                    .get('persistent.debugger_checkout_offer_validation_skip')
                    .then(function(values){
                        var skipOfferValidation = values && values[0] && values[0].value;
                        if ( skipOfferValidation === true ) {
                            return RSVP.resolve();
                        }

                        return getOffer().then(
                            function(defaultOffer){
                                var err = createError('offer', 'Offer is not available for current user.');
                                state.push('session.recommendedOffer', defaultOffer.Id);
                                me.emit('error', err);
                                return RSVP.reject(err);
                            },
                            function(){
                                return RSVP.reject(createError(null, 'Failed to retrieve offer'));
                            }
                        );

                    });
            })
        );
    }

    function Ctor(){
        var me = this;
        me.dfdOfferValidatable = [];
    }
    var p = Ctor.prototype;

    p.doPageLoad = function() {
        var me = this;
        var wcmmode;
        return RSVP.resolve()
        .then(function(){
            return getWCMMode();
        })
        .then(function(value){
            wcmmode = value;
        })
        .then(function(){
            return state.retrieve(constants.State.OrderOfferId);
        })
        .then(function(value){
            var offerIds = Array.isArray(value)?value:[value];
            for(var i = 0; i < offerIds.length; i++) {
                validate.call(me, offerIds[i], wcmmode);
            }
        });
    };

    return Ctor;
});
